export enum Perk {
  Color = "Color",
  Rainbow = "Rainbow"
}

export type PerkValues = {
  [perk in Perk]: any;
};